import http from './http';

export function fetchProfile() {
  return http.get('/profile');
}

export function changePassword(currentPassword, newPassword) {
  return http.put('/profile/password', {
    currentPassword,
    newPassword
  });
}
